import { get } from './api.service'

export default {

  getEducationTypes (params: any) {
    return get ('/education-types', params)
  }

}